module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/experience01-d95d08f6b0c97b736ce8259970714607.svg";